import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import isEmpty from 'lodash/isEmpty';

const buildGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const getCurrentOpenDialog = buildGetterObject('getCurrentOpenDialog');
export const isDialogActive = buildGetterObject('isDialogActive');
export const getOpenDialogs = buildGetterObject('getOpenDialogs');

const getters = {
	[getCurrentOpenDialog.getter]: (state) => state.openDialogs.at(-1),
	// dialogs are pushed to the array in LIFO order
	[getOpenDialogs.getter]: (state) => state.openDialogs,
	// state.isDialogActive used by UserMatchingMixin only,
	// go to `$data._userMatchingDialog` watch in UserMatchingMixin before extending the use of if.
	// probably if you want to use it to another use case, you should do it through AppDialogManager
	// it's here to allow manually mark as there is opened dialog, even though it wasn't open from dialogs store module
	[isDialogActive.getter]: (state) => !isEmpty(state.openDialogs) || state.isDialogActive,
};

export default getters;
